import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

totalStyles.container = {
    gap: 10,
    css: css`
        background-color: ${getColor("common.accent")};
        padding: 20px;
        @media print {
            background-color: #fff;
            border: 1px solid #f2f2f2;
            padding: 0;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    padding: 15px 15px 0;
                    &:last-child {
                        border-top: 1px solid #f2f2f2;
                        padding-bottom: 15px;
                        padding-top: 10px;
                        margin-top: 15px;
                    }
                    &:nth-last-child(2) {
                        border-top: 1px solid #f2f2f2;
                        padding-bottom: 15px;
                        padding-top: 10px;
                        margin-top: 15px;
                    }
                }
            }
        }
    `,
};

totalStyles.valueGridItem = {
    width: 6,
    css: css`
        @media print {
            display: flex;
            justify-content: flex-end;
            text-align: right;
        }
    `,
};
